/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { Text, TextProps } from '@mantine/core'

export type RefProps = TextProps & {
  value: string | number
}

function Ref (props: RefProps) {
  const { value, ...others } = props
  return (
    <Text
      inherit
      span
      {...others}
    >
      {value}
    </Text>
  )
}

export default Ref
